import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import produce from 'immer';
import { getMeetgoApplicationInfo, getMeetgoApplicationInfoByReservationId, getHomeServiceCarSimple } from 'app/api';
import set from 'lodash/set';
import merge from 'lodash/merge';

const GET_MEETGO_APPLICATION_INFO = 'meetgo';
const GET_MEEOGO_APPLICATION_BY_RESERVATIONID_INFO = 'meetgo';
const GET_HOMESERVICE_CHECK_INFO = 'meetgo.application';

export const getMeetgoApplicationInfoAction = createAction(GET_MEETGO_APPLICATION_INFO, getMeetgoApplicationInfo);

export const getMeetgoApplicationInfoByReservationIdAction = createAction(
	GET_MEEOGO_APPLICATION_BY_RESERVATIONID_INFO,
	getMeetgoApplicationInfoByReservationId,
);

export const getHomeServiceCheckInfoAction = createAction(GET_HOMESERVICE_CHECK_INFO, getHomeServiceCarSimple);

const initialState = {
	uuid: '',
	applicant: {
		userId: '',
		name: '',
		phone: '',
		refundAccount: {
			name: '',
			bank: '',
			number: '',
		},
		nominees: [
			{
				id: 1,
				applicantType: '',
				nomineeType: '',
				name: '',
				phone: '',
				birth: '',
				gender: '',
				certifiedAddress: {
					buildingCd: '',
					detail: '',
				},
				postalAddress: {
					buildingCd: '',
					detail: '',
				},
				businessName: '',
				businessNumber: '',
				businessAddress: {
					buildingCd: '',
					detail: '',
				},
				ownershipRate: 1,
				invoice: {
					type: '',
					issueRequest: true,
					email: '',
				},
			},
		],
	},
	car: {
		carId: '',
		modelName: '',
		plate: '',
	},
	seller: {
		id: '',
		name: '',
		phone: '',
	},
	company: {
		code: '',
		name: '',
		dealershipCode: '',
		dealershipName: '',
	},
	lastProgress: '',
	consultant: {
		id: '',
		name: '',
		phone: '',
	},
	estimate: {
		carPrice: 1,
		transferCost: 96,
		sellingCost: 330000,
		inspectionInsuranceFee: 0,
		userFee: 110000,
		extendedWarrantyCost: 0,
	},
	extendedWarranty: {
		month: 0,
		cost: 0,
		type: 'A',
	},
	payment: {
		uplus: {},
		paymentV2: {},
		firstPaymentMethod: '',
		activePaymentMethods: '',
	},
	refund: {
		id: 4,
		refundReason: '',
		pictures: [],
		createdAt: 1672731309351,
	},
	progresses: [
		{
			id: 6,
			type: '',
			createdAt: 1672648723386,
		},
	],
	reservationId: '',
	visitCenterName: '',
	reservationVisitAt: 0,
	reservationAt: 0,
	createdAt: 0,
};

export default handleActions(
	{
		[GET_MEETGO_APPLICATION_INFO]: (state, action) =>
			produce(state, (draft) => {
				const { application } = action.payload;
				draft.application = application;
				return draft;
			}),
		...pender({
			type: GET_MEETGO_APPLICATION_INFO,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					merge(draft, data);
					// set(draft, 'application', data);
				}),
		}),
		[GET_MEEOGO_APPLICATION_BY_RESERVATIONID_INFO]: (state, action) =>
			produce(state, (draft) => {
				const { application } = action.payload;
				draft.application = application;
				return draft;
			}),
		...pender({
			type: GET_MEEOGO_APPLICATION_BY_RESERVATIONID_INFO,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					merge(draft, data);
				}),
		}),
		[GET_HOMESERVICE_CHECK_INFO]: (state, action) =>
			produce(state, (draft) => {
				const { application } = action.payload;
				draft.application = application;
				return draft;
			}),
		...pender({
			type: GET_HOMESERVICE_CHECK_INFO,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, 'simple', data);
				}),
		}),
	},
	initialState,
);
